import React, { useLayoutEffect, useRef, useState } from 'react'
import { ColumnManager } from '../../../utils/ColumnManager'

const OrdersTooltip = ({ orders, columnKey, onMouseEnter, onMouseLeave }) => {
  const tooltipRef = useRef(null)
  const [alignment, setAlignment] = useState({
    left: '50%',
    transform: 'translateX(-50%)'
  })

  useLayoutEffect(() => {
    if (!tooltipRef.current) return
    const rect = tooltipRef.current.getBoundingClientRect()
    const viewportWidth = window.innerWidth

    if (rect.right > viewportWidth - 8) {
      setAlignment({ left: 'auto', right: 0, transform: 'none' })
    } else if (rect.left < 8) {
      setAlignment({ left: 0, transform: 'none' })
    }
  }, [])
  if (!orders || orders.length === 0) return null

  const { customerCode, branchCode } = ColumnManager.parseColumnKey(columnKey)

  const rows = []
  orders.forEach((entry) => {
    const hic = entry.hic
    const ordersList = entry.orders_list || []

    ordersList.forEach((o) => {
      const codeMatch = String(o.customer_code ?? '') === String(customerCode)
      const branchMatch = String(o.branch_code ?? '') === String(branchCode)

      if (codeMatch && branchMatch) {
        rows.push({ hic, ...o })
      }
    })
  })

  if (rows.length === 0) return null

  return (
    <div
      className="orders-tooltip"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        position: 'absolute',
        top: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 99999,
        pointerEvents: 'auto',
        marginTop: 4,
        ...alignment
      }}
    >
      <div
        ref={tooltipRef}
        style={{
          background: '#1e2330',
          border: '1px solid #3a4460',
          borderRadius: 6,
          boxShadow: '0 8px 24px rgba(0,0,0,0.45)',
          minWidth: 320,
          overflow: 'hidden',
          fontFamily: 'monospace',
          maxHeight: 300,
          overflowY: 'auto'
        }}
      >
        <div
          style={{
            background: '#2a3350',
            padding: '6px 10px',
            fontSize: 11,
            color: '#8ab4f8',
            fontWeight: 700,
            letterSpacing: '0.05em',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <span>注文情報</span>
          <span style={{ color: '#64748b', fontWeight: 400 }}>
            {customerCode}
            {branchCode ? ` / ${branchCode}` : ''}
          </span>
        </div>

        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: 11
          }}
        >
          <thead>
            <tr style={{ background: '#252d42' }}>
              {['品目', '等級', '階級', '産地', '数量'].map((h) => (
                <th
                  key={h}
                  style={{
                    padding: '5px 8px',
                    color: '#94a3b8',
                    fontWeight: 600,
                    textAlign: 'center',
                    borderBottom: '1px solid #3a4460',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr
                key={i}
                style={{
                  background: i % 2 === 0 ? 'transparent' : '#1a2035',
                  borderBottom: '1px solid #2a3350'
                }}
                className='text-[1px]'
              >
                <td style={tdStyle('#60a5fa')}>{row.hic ?? '-'}</td>
                <td style={tdStyle()}>{row.grade ?? '-'}</td>
                <td style={tdStyle()}>{row.size ?? '-'}</td>
                <td style={tdStyle('#86efac')}>{row.production ?? '-'}</td>
                <td style={{ ...tdStyle('#fbbf24'), fontWeight: 700 }}>
                  {row.order_quantity ?? '-'}
                </td>
              </tr>
            ))}
          </tbody>
          {rows.length > 1 && (
            <tfoot>
              <tr
                style={{
                  background: '#2a3350',
                  borderTop: '2px solid #3a4460'
                }}
              >
                <td
                  colSpan={4}
                  style={{
                    padding: '5px 8px',
                    color: '#94a3b8',
                    textAlign: 'right',
                    fontSize: 10
                  }}
                >
                  合計
                </td>
                <td
                  style={{
                    ...tdStyle('#fbbf24'),
                    fontWeight: 700,
                    borderTop: 'none'
                  }}
                >
                  {rows.reduce(
                    (s, r) => s + (Number(r.order_quantity) || 0),
                    0
                  )}
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  )
}

function tdStyle(color) {
  return {
    padding: '5px 8px',
    color: color || '#e2e8f0',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    fontSize: 14,
    wordBreak: 'break-word'
  }
}

export default OrdersTooltip
